<template>
  <p class="text-gray-400 leading-loose">{{ text }}</p>
</template>

<script>
export default {
  props: ['text']
};
</script>